// Auto-generated skeleton for SourceResource

export const SourceResource: Api.SourceResource = {
  id: 0,
  name: '',
  type: '',
};

